import {Component, Input} from '@angular/core';
import {
  StartEmbeddedSignupButtonComponent
} from '../start-embedded-signup-button/start-embedded-signup-button.component';
import {OnboardingType} from '../../enums/onboarding-type';
import {PageStateService} from '../../services/page-state.service';
import {Observable} from 'rxjs';
import {PageState} from '../../enums/page-state.enum';
import {AsyncPipe} from '@angular/common';
import {DisplayMessageComponent} from '../display-message/display-message.component';
import {MessageType} from '../../enums/message-type';
import {SpinnerComponent} from '../spinner/spinner.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-start-embedded-signup',
  imports: [
    StartEmbeddedSignupButtonComponent,
    AsyncPipe,
    DisplayMessageComponent,
    SpinnerComponent,
    TranslatePipe
  ],
  templateUrl: './start-embedded-signup.component.html',
  styleUrl: './start-embedded-signup.component.scss'
})
export class StartEmbeddedSignupComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('onboarding-type')
  public onboardingType: OnboardingType | undefined = undefined;

  public readonly pageState: Observable<PageState>;
  public readonly locale: Intl.Locale;

  protected readonly PageState = PageState;
  protected readonly MessageType = MessageType;

  public constructor(
    private readonly pageStateService: PageStateService,
    private readonly translateService: TranslateService
  ) {
    this.pageState = this.pageStateService.state;
    this.locale = new Intl.Locale(navigator.language);
    this.translateService.use(this.locale.language);
  }
}
